import { MoneyAmount, TripBuddy, TripDetail } from "./types";
import { BUDDY_STATUS, CERTIFICATION_LEVEL } from "./constants";

export const formatTripDate = (iso?: string) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const formatTripDateRange = (from?: string, to?: string) => {
  const start = formatTripDate(from);
  const end = formatTripDate(to);
  if (start && end) return `${start} – ${end}`;
  return start || end || "";
};

export const formatMoney = (amount?: MoneyAmount | null) => {
  if (!amount || amount.value == null) return "";
  const currency = amount.currency || "";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      maximumFractionDigits: 2,
    }).format(amount.value);
  } catch {
    return `${currency} ${amount.value}`.trim();
  }
};

export const getBuddyName = (buddy?: TripBuddy) => {
  if (!buddy) return "";
  return [buddy.firstName, buddy.lastName].filter(Boolean).join(" ").trim();
};

export const getBuddyInitials = (buddy?: TripBuddy) => {
  const name = getBuddyName(buddy);
  if (!name) return "DB";
  return name
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};

export const getTripBuddies = (trip: TripDetail): TripBuddy[] => {
  return trip.buddies?.length
    ? trip.buddies
    : trip.invitedBuddies?.length
      ? trip.invitedBuddies
      : [];
};

export const getTripTotalBudget = (trip: TripDetail): MoneyAmount | null => {
  return trip.tripBudget?.totalBudget || trip.totalBudget || null;
};

export const getCertificationLabel = (level: string | number) => {
  const key = String(level);
  return CERTIFICATION_LEVEL[key] || `Level ${key}`;
};

export const getBuddyStatusLabel = (status?: number) => {
  if (status == null) return "";
  return BUDDY_STATUS[status] || `Status ${status}`;
};

export const hasChecklistContent = (
  checklist?: TripDetail["checklist"]
): boolean => {
  if (!checklist) return false;
  const hasDays =
    checklist.days &&
    Object.values(checklist.days).some((items) => items?.length);
  const hasPlans =
    checklist.tripPlans &&
    Object.values(checklist.tripPlans).some((items) => items?.length);
  return Boolean(hasDays || hasPlans);
};
